import styled from "styled-components";

/**
 * Wrapper principal do filtro de entidades.
 */
export const EntityFilterWrapper = styled.div`
  gap: ${({ theme }) => theme.spacing(3)};
  flex-direction: column;
  display: flex;
  width: 100%;
`;

/**
 * Item individual na lista de entidades.
 */
export const EntityItem = styled.div`
  gap: ${({ theme }) => theme.spacing(2)};
  width: 100%;
  align-items: center;
  position: relative;
  display: flex;

  input {
    min-width: ${({ theme }) => theme.spacing(3)};
  }

  span {
    margin-left: ${({ theme }) => theme.spacing(8)};
  }

  img {
    width: ${({ theme }) => theme.spacing(6)};
    left: ${({ theme }) => theme.spacing(5)};
    position: absolute;
    object-fit: contain;
  }
`;
